export enum BottomTab {
  RiskDetails = "Risk details",
  Accumulations = "Accumulations",
  Query = "Query",
  Groups = "Groups",
}
